import { useQuery } from '@tanstack/react-query';

import type { LegacyLimaConnection } from './MsDefenderIntegration.types';

export const useFetchLegacyLimaConnections = (
  organizationLabel: string | undefined,
  hasAdminRead: boolean
) => {
  const url = organizationLabel
    ? `organizations/${organizationLabel}/integrations/microsoft/legacy_lima_connections`
    : '';

  return useQuery<LegacyLimaConnection[]>({
    queryKey: [url],
    enabled: hasAdminRead && !!organizationLabel && organizationLabel !== 'all'
  });
};
